import Em from 'ember';
export default Em.Object.extend({
  shouldRerender: false
});